import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { FeeProviderLocationType } from 'constants/feeProviders';

import { getSystem } from './system.selectors';

export const selectFeeProviders = createSelector(getSystem, ({ feeProvider }) => feeProvider);

export const selectFeeProviderValues = createSelector(selectFeeProviders, Object.values);

export const selectFeeProviderOptions = createSelector(selectFeeProviderValues, feeProviders =>
  feeProviders.map(provider => ({ ...provider, value: provider.feeProviderId })),
);

export const selectFeeProviderById = memoizeOne(id =>
  createSelector(selectFeeProviders, feeProviders => {
    const feeProvider = feeProviders[id] || {};
    const primaryLocation = feeProvider?.locations?.find(
      ({ type }) => type === FeeProviderLocationType.PRIMARY,
    );

    const formattedLocations = feeProvider?.locations?.map(location => {
      const { bank, abaNumber, accountNumber: wireAccountNumber } = location.wireInformation || {};

      return {
        ...location,
        accountName: bank,
        accountNumber: wireAccountNumber,
        routingNumber: abaNumber,
      };
    });

    return {
      ...feeProvider,
      locations: formattedLocations,
      ..._.omit(primaryLocation, ['accountName', 'routingNumber', 'accountNumber']),
    };
  }),
);
